import React, { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-apollo';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';

import OfferDetails from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/components/OfferDetails/OfferDetails';
import OfferSegments from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/components/OfferSegments/OfferSegments';
import { OfferSummary } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.types';
import { handleError } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.helpers';

import styles from './PulseOffer.styles';
import GET_OFFER from './PulseOffer.queries';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
};

type Response = {
  offerGetByUuid: OfferSummary;
};

const PulseOffer: FunctionComponent<Props> = ({ classes }) => {
  const { offerUuid = '' } = useParams<any>();
  const [offer, setOffer] = useState<OfferSummary>();

  const { data } = useQuery<Response>(GET_OFFER, {
    variables: {
      params: {
        offerUuid,
        hydrateFinancialTerms: true,
      },
    },
    onError: handleError,
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    if (data) {
      const { offerGetByUuid } = data;
      setOffer(offerGetByUuid);
    }
  }, [data]);

  return (
    <>
      <h2 className={classes.topHeader}>Offer</h2>
      <OfferDetails offer={offer} />
      <OfferSegments segments={offer?.segments} offer={offer} />
    </>
  );
};

export default withStyles(styles)(PulseOffer);
